.shell {
  width: min(1280px, calc(100% - 2rem));
  margin: 1rem 0 4rem 1rem;
}

.planner {
  display: grid;
  grid-template-columns: 522px minmax(520px, 1fr);
  align-items: start;
  gap: 1rem;
}

.sidebar {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  min-width: 0;
  gap: 1rem;
}

.sidebar > :first-child,
.sidebar > :last-child {
  grid-column: 1 / -1;
}

@media (max-width: 1080px) {
  .shell {
    width: calc(100% - 1rem);
    margin-top: 0.5rem;
  }

  .planner {
    grid-template-columns: minmax(0, 1fr);
  }

  .planner > section:first-child {
    justify-self: start;
  }

  .sidebar {
    width: min(522px, 100%);
    justify-self: start;
  }
}

@media (max-width: 560px) {
  .planner {
    overflow-x: auto;
  }

  .sidebar {
    min-width: 490px;
  }
}
